import { render } from "./CreateProject.vue?vue&type=template&id=57ca7d67&scoped=true"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"

import "./CreateProject.vue?vue&type=style&index=0&id=57ca7d67&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-57ca7d67"

export default script